import {
    USER_LOGIN_REQUEST,
    USER_LOGIN_SUCCESS,
    USER_LOGIN_FAIL,
    USER_LOGOUT,
    USER_REGISTER_REQUEST,
    USER_REGISTER_SUCCESS,
    USER_REGISTER_FAIL,
    ONBOARD_FIRST_STEP_REQUEST,
    ONBOARD_FIRST_STEP_SUCCESS,
    ONBOARD_FIRST_STEP_FAIL,
    ONBOARD_SECOND_STEP_REQUEST,
    ONBOARD_SECOND_STEP_SUCCESS,
    ONBOARD_SECOND_STEP_FAIL,
    ONBOARD_THIRD_STEP_REQUEST,
    ONBOARD_THIRD_STEP_SUCCESS,
    ONBOARD_THIRD_STEP_FAIL,
    ONBOARD_FINAL_REQUEST,
    ONBOARD_FINAL_SUCCESS,
    ONBOARD_FINAL_FAIL,
    USER_PROFILE_REQUEST,
    USER_PROFILE_SUCCESS,
    USER_PROFILE_FAIL,
    USER_TOUR_SHOW,
    USER_TOUR_HIDE,
    PAYMENT_CHECKOUT_REQUEST,
    PAYMENT_CHECKOUT_SUCCESS,
    PAYMENT_CHECKOUT_FAIL,
    PAYMENT_CHECKOUT_RESET,
    PAYMENT_VALIDATE_REQUEST,
    PAYMENT_VALIDATE_SUCCESS,
    PAYMENT_VALIDATE_FAIL,
    PAYMENT_VALIDATE_RESET,
} from '../constants/userConstants'

export const userLoginReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_LOGIN_REQUEST:
            return { loading: true }
        case USER_LOGIN_SUCCESS:
            return { loading: false, userInfo: action.payload }
        case USER_LOGIN_FAIL:
            return { loading: false, error: action.payload }
        case USER_LOGOUT:
            return {}
        default:
            return state
    }
}

export const userRegisterReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_REGISTER_REQUEST:
            return { loading: true }
        case USER_REGISTER_SUCCESS:
            return { loading: false, userInfo: action.payload }
        case USER_REGISTER_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}

export const onboardFirstStepReducer = (state = {}, action) => {
    switch (action.type) {
        case ONBOARD_FIRST_STEP_REQUEST:
            return { loading: true }
        case ONBOARD_FIRST_STEP_SUCCESS:
            return { loading: false, firstStepData: action.payload }
        case ONBOARD_FIRST_STEP_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}

export const onboardSecondStepReducer = (state = {}, action) => {
    switch (action.type) {
        case ONBOARD_SECOND_STEP_REQUEST:
            return { loading: true }
        case ONBOARD_SECOND_STEP_SUCCESS:
            return { loading: false, secondStepData: action.payload }
        case ONBOARD_SECOND_STEP_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}

export const onboardThirdStepReducer = (state = {}, action) => {
    switch (action.type) {
        case ONBOARD_THIRD_STEP_REQUEST:
            return { loading: true }
        case ONBOARD_THIRD_STEP_SUCCESS:
            return { loading: false, thirdStepData: action.payload }
        case ONBOARD_THIRD_STEP_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}

export const onboardFinalStepReducer = (state = {}, action) => {
    switch (action.type) {
        case ONBOARD_FINAL_REQUEST:
            return { loading: true }
        case ONBOARD_FINAL_SUCCESS:
            return { loading: false, finalStepData: action.payload }
        case ONBOARD_FINAL_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}

export const userProfileReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_PROFILE_REQUEST:
            return { loading: true }
        case USER_PROFILE_SUCCESS:
            return { loading: false, userData: action.payload }
        case USER_PROFILE_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}

export const userTourReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_TOUR_SHOW:
            return { tourData: action.payload }
        case USER_TOUR_HIDE:
            return {}
        default:
            return state
    }
}

export const paymentCheckoutReducer = (state = {}, action) => {
    switch (action.type) {
        case PAYMENT_CHECKOUT_REQUEST:
            return { loading: true }
        case PAYMENT_CHECKOUT_SUCCESS:
            return { loading: false, checkoutInfo: action.payload }
        case PAYMENT_CHECKOUT_FAIL:
            return { loading: false, error: action.payload }
        case PAYMENT_CHECKOUT_RESET:
            return {}
        default:
            return state
    }
}

export const paymentValidateReducer = (state = {}, action) => {
    switch (action.type) {
        case PAYMENT_VALIDATE_REQUEST:
            return { loading: true }
        case PAYMENT_VALIDATE_SUCCESS:
            return { loading: false, validateInfo: action.payload }
        case PAYMENT_VALIDATE_FAIL:
            return { loading: false, error: action.payload }
        case PAYMENT_VALIDATE_RESET:
            return {}
        default:
            return state
    }
}